import { IAlert } from '../../../shared/components/CustomAlert'
import { GridSetup, IRole, ReportDetail } from '../models/role-model'

export const ROLE_FORM_DEFAULT: IRole = {
  id: '',
  name: '',
  displayId: 0
}

export const Initial_GridSetup: GridSetup = {
  sort: [{ field: 'id', dir: 'desc' }],
  skip: 0,
  take: 10,
  filter: {
    logic: 'and',
    filters: []
  }
}

export const TOASTER_DEFAULT: IAlert = {
  message: ``,
  header: ``,
  type: 'success'
}

export enum REPORT_NAMES {
  Report1 = 'Executive Summary',
  Report2 = 'Health & Safety',
  Report3 = 'Risk',
  Report4 = 'Cost',
  Report5 = 'Schedule',
  Report6 = 'People',
  Report7 = 'Progress'
}

export enum USER_ROLES {
  Administrator = 'Administrator',
  User = 'User'
}

export enum PAGE_PERMISSION {
  Dashboard = 'Dashboard',
  Chargers = `Chargers`,
  Locations = `Locations`,
  Faulted_Assets = `FaultedAssets`,
  Service_Tickets = `ServiceTickets`,
  Reports = `Reports`,
  
  Admin_Users = `Administration.Users`,
  Admin_Charts = `Administration.Charts`,
  Admin_Roles = `Administration.Roles`,
  Admin_Settings = `Administration.Settings`,
  Admin_Features = `Administration.Features`,
  Admin_Audit = `Administration.Audit`,
  Admin_Groups = `Administration.Groups`,
}
